<template>
    <div class="search-adsac" :class="theme">
        <div class="search-adsac-inner-container brand inline active large grid xs-grid-cols-1">
            <div class="middle grid xs-grid-cols-1" v-ga:impression="theme === 'lead-banner' ? 'agentconnect_msp_leadform' : 'agentconnect_msp_tile'">
                <div class="adsac_logo">
                    <img :src="glb.cdnUrl + 'vimages/movoto-lower-logo-m-white.svg'" alt="Movoto Logo" loading="lazy"/>
                </div>
                <div>
                    <div class="banner-title">Don’t see what you’re looking for?</div>
                    <div class="banner-content">A local real estate agent is the best way to get access to exclusive and off-market properties so you can find <span>home</span>.</div>
                </div>
                <div v-if="theme !== 'lead-banner'">
                    <button v-ga:clickable @click="openConnectAgentHotlead" type="button" class="btn secondary small">Connect with an agent</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="./search-adsagentconnection.js"></script>
<style lang="scss">
@use "./search-adsagentconnection.scss" as *;
</style>
